import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { buildHead } from "@/lib/seo";

const OG_IMAGE =
  "https://vibe.filesafe.space/1779750798598342338/attachments/d7bd12bd-9100-46e0-8b4e-c8e0403c6bbb.png";

// LocalBusiness structured data — present in the initial SSR HTML so search
// engines can parse the business NAP, service area, and offerings.
const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  name: "Precision Pavers & Pool Design",
  url: "https://precisionpaverspools.com/",
  telephone: "+1-954-200-3501",
  email: "precisionpaver@gmail.com",
  description:
    "Pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Broward County, FL.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "605 SW 9th Terrace",
    addressLocality: "Pompano Beach",
    addressRegion: "FL",
    postalCode: "33069",
    addressCountry: "US",
  },
  areaServed: [
    { "@type": "City", name: "Fort Lauderdale" },
    { "@type": "City", name: "Coral Springs" },
    { "@type": "City", name: "Pembroke Pines" },
    { "@type": "City", name: "Weston" },
    { "@type": "City", name: "Miramar" },
    { "@type": "City", name: "Sunrise" },
    { "@type": "City", name: "Davie" },
    { "@type": "City", name: "Miami" },
    { "@type": "City", name: "Tampa" },
    { "@type": "City", name: "Orlando" },
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Outdoor Living Services",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Pool Remodeling & Resurfacing",
        },
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Pool Deck Remodeling" },
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Driveway & Patio Pavers" },
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Outdoor Enhancements" },
      },
    ],
  },
  sameAs: [
    "https://www.facebook.com/precisionpaverspools",
    "https://www.instagram.com/precisionpaverspools",
    "https://www.youtube.com/precisionpavers",
    "https://www.yelp.com/biz/precision-pavers-and-pool-design-pompano-beach",
    "https://www.tiktok.com/@precisionpavers",
  ],
};

export const Route = createFileRoute("/")({
  head: () =>
    buildHead({
      title:
        "Pool Remodeling, Pavers & Deck Resurfacing in Broward County, FL | Precision Pavers & Pool Design",
      description:
        "Premium pool remodeling, deck resurfacing, driveway pavers, artificial turf, and outdoor enhancements across Fort Lauderdale, Coral Springs, Weston, and all of Broward County. Family-owned. Free estimates. Visit our Pompano Beach showroom.",
      path: "/",
      ogImage: OG_IMAGE,
      jsonLd: localBusinessJsonLd,
    }),
  component: Index,
});
